import { PushType } from '../../enum/push-type';
import { NotificationResponse } from './notification-response';


export class MissionNotification {
    id: string;
    name: string;
    tagScanned: boolean;
    notificationId?: string;
    stepId?: string;
    stepName?: string;
    status?: string;
    icon?: string;
    sentOn?: Date;

    constructor(response: NotificationResponse) {
        this.notificationId = response.id || null;
        this.id = response.payload.id;
        this.name = response.payload.name;
        this.tagScanned = response.payload.tagScanned;

        this.stepId = response.payload.stepId || null;
        this.stepName = response.payload.stepName || null;

        this.sentOn = response.createdOn || new Date();

        this.status = 'main.notifications.missions.';

        switch (response.type) {
            case PushType.MediaUploaded:
                this.status += 'created';
                this.icon = 'add';
                break;

            default:
                this.status += 'updated';
        }
    }
}
